import { NgModule } from "@angular/core";
import { CommonDataModule } from "FoxxyLib";

@NgModule({
  imports: [CommonDataModule],
  exports: [CommonDataModule]
})
export class AppCommonModule { }
